// extracted by mini-css-extract-plugin
module.exports = {"articlesContainer":"C_cF","articlesContent":"C_cG","lastes":"C_cH","popular":"C_cJ","article":"C_cK","sectionTitle":"C_8","imgArticle":"C_cL","articleDate":"C_cM"};